import { render, staticRenderFns } from "./projectWorks.vue?vue&type=template&id=a43618b6&scoped=true"
import script from "./projectWorks.vue?vue&type=script&lang=js"
export * from "./projectWorks.vue?vue&type=script&lang=js"
import style0 from "./projectWorks.vue?vue&type=style&index=0&id=a43618b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43618b6",
  null
  
)

export default component.exports